import React from "react";

import Highlight from "./Highlight";

import { StyledHighlights } from "./style";

const Highlights = ({ highlights }) =>
  highlights?.length > 0 && (
    <StyledHighlights>
      {highlights?.map((highlight, index) => (
        <Highlight key={index + Math.random().toString()} {...highlight} />
      ))}
    </StyledHighlights>
  );

export default Highlights;
